<script>
	import { createEventDispatcher } from "svelte";
	import {
		Button,
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
	} from "@sveltestrap/sveltestrap";

	export let isOpen = false;
	export let title = "Discard changes?";
	export let text =
		"You have unsaved changes. If you leave this page, the details you entered will be lost.";
	export let confirmText = "Discard";
	export let disabled = false;

	const dispatch = createEventDispatcher();
	const keepEditing = () => dispatch("cancel");
	const discard = () => dispatch("confirm");
</script>

<Modal {isOpen} toggle={keepEditing} centered>
	<ModalHeader class="discard-changes-modal-header">{title}</ModalHeader>
	<ModalBody>
		<p class="discard-changes-text">{text}</p>
	</ModalBody>
	<ModalFooter>
		<Button
			class="themeButton backButton px-4"
			{disabled}
			on:click={keepEditing}
		>
			Keep editing
		</Button>
		<Button class="themeButton primary px-4" {disabled} on:click={discard}>
			{confirmText}
		</Button>
	</ModalFooter>
</Modal>

<style>
	:global(.discard-changes-modal-header .modal-title) {
		font-size: 20px;
		font-weight: 700;
		line-height: 28px;
		color: var(--fds-on-surface-container, #00071f);
	}

	.discard-changes-text {
		margin: 0;
		font-size: 16px;
		line-height: 20px;
		color: var(--fds-on-surface-container, #00071f);
	}
</style>
